/**
 * ChromeWrapper
 * Class for working with Chrome Extension and plugin, since Chrome's implementation works differently
 * than the NPAPI plugin for IE/FireFox/Safari
 * Main intent is to wrap ChromeProxy
 */

const EventNames = {
    99:  'VIDYO_CLIENT_IN_EVENT_MIN',
    100: 'VIDYO_CLIENT_OUT_EVENT_USER_MESSAGE',
    200: 'VIDYO_CLIENT_OUT_EVENT_LOGIC_STARTED',
    300: 'VIDYO_CLIENT_OUT_EVENT_SIGN_IN',
    301: 'VIDYO_CLIENT_OUT_EVENT_SIGN_OUT',
    400: 'VIDYO_CLIENT_OUT_EVENT_SUBSCRIBING',
    500: 'VIDYO_CLIENT_OUT_EVENT_APP_EXIT',
    600: 'VIDYO_CLIENT_OUT_EVENT_DEVICE_SELECT',
    601: 'VIDYO_CLIENT_OUT_EVENT_DEVICES_CHANGED',
    602: 'VIDYO_CLIENT_OUT_EVENT_DEVICE_SELECTION_CHANGED',
    603: 'VIDYO_CLIENT_OUT_EVENT_SELECTED_DEVICE_ON_OS_CHANGED',
    700: 'VIDYO_CLIENT_OUT_EVENT_RINGING',
    701: 'VIDYO_CLIENT_OUT_EVENT_RING_PROGRESS',
    702: 'VIDYO_CLIENT_OUT_EVENT_END_RINGING',
    800: 'VIDYO_CLIENT_OUT_EVENT_CALLING',
    801: 'VIDYO_CLIENT_OUT_EVENT_CALL_PROGRESS',
    802: 'VIDYO_CLIENT_OUT_EVENT_END_CALLING',
    900: 'VIDYO_CLIENT_OUT_EVENT_JOINING',
    901: 'VIDYO_CLIENT_OUT_EVENT_JOIN_PROGRESS',
    1000: 'VIDYO_CLIENT_OUT_EVENT_RETRYING',
    1001: 'VIDYO_CLIENT_OUT_EVENT_RETRY_PROGRESS',
    1100: 'VIDYO_CLIENT_OUT_EVENT_END_PROCESSING',
    1200: 'VIDYO_CLIENT_OUT_EVENT_CONFERENCE_ACTIVE',
    1201: 'VIDYO_CLIENT_OUT_EVENT_CONFERENCE_ENDED',
    1202: 'VIDYO_CLIENT_OUT_EVENT_PARTICIPANTS_CHANGED',
    1203: 'VIDYO_CLIENT_OUT_EVENT_CONFERENCE_CLEARED',
    1210: 'VIDYO_CLIENT_OUT_EVENT_REMOTE_SOURCE_ADDED',
    1211: 'VIDYO_CLIENT_OUT_EVENT_REMOTE_SOURCE_REMOVED',
    1300: 'VIDYO_CLIENT_OUT_EVENT_INCOMING_CALL',
    1301: 'VIDYO_CLIENT_OUT_EVENT_END_INCOMING_CALL',
    1400: 'VIDYO_CLIENT_OUT_EVENT_PREVIEW',
    1500: 'VIDYO_CLIENT_OUT_EVENT_MUTED_AUDIO_IN',
    1501: 'VIDYO_CLIENT_OUT_EVENT_MUTED_AUDIO_OUT',
    1502: 'VIDYO_CLIENT_OUT_EVENT_MUTED_VIDEO',
    1503: 'VIDYO_CLIENT_OUT_EVENT_MUTED_SERVER_AUDIO_IN',
    1504: 'VIDYO_CLIENT_OUT_EVENT_MUTED_SERVER_VIDEO',
    1600: 'VIDYO_CLIENT_OUT_EVENT_ADD_SHARE',
    1601: 'VIDYO_CLIENT_OUT_EVENT_REMOVE_SHARE',
    1602: 'VIDYO_CLIENT_OUT_EVENT_SHARE_CLOSED',
    1700: 'VIDYO_CLIENT_OUT_EVENT_RESIZE',
    1800: 'VIDYO_CLIENT_OUT_EVENT_PARTICIPANTS_LIMIT',
    1900: 'VIDYO_CLIENT_OUT_EVENT_ECHO_DETECTED',
    2000: 'VIDYO_CLIENT_OUT_EVENT_KEYDOWN',
    2001: 'VIDYO_CLIENT_OUT_EVENT_KEYUP',
    2002: 'VIDYO_CLIENT_OUT_EVENT_MOUSE_DOWN',
    2003: 'VIDYO_CLIENT_OUT_EVENT_MOUSE_UP',
    2004: 'VIDYO_CLIENT_OUT_EVENT_MOUSE_MOVE',
    2005: 'VIDYO_CLIENT_OUT_EVENT_MOUSE_SCROLL',
    2006: 'VIDYO_CLIENT_OUT_EVENT_TOUCH',
    2007: 'VIDYO_CLIENT_OUT_EVENT_FLOATING_WINDOW',
    2100: 'VIDYO_CLIENT_OUT_EVENT_FECC_LIST_UPDATED',
    2101: 'VIDYO_CLIENT_OUT_EVENT_CONTROL_CAMERA',
    2102: 'VIDYO_CLIENT_OUT_EVENT_SET_PARTICIPANT_VIDEO_MODE_DONE',
    2103: 'VIDYO_CLIENT_OUT_EVENT_CONFERENCE_INFO_UPDATE',
    2104: 'VIDYO_CLIENT_OUT_EVENT_FECC_STATUS_UPDATE',
    2105: 'VIDYO_CLIENT_OUT_EVENT_PARTICIPANT_BUTTON_CLICK',
    2200: 'VIDYO_CLIENT_OUT_EVENT_MEDIA_CONTROL',
    2300: 'VIDYO_CLIENT_OUT_EVENT_LOGIN',
    2301: 'VIDYO_CLIENT_OUT_EVENT_LICENSE',
    2302: 'VIDYO_CLIENT_OUT_EVENT_LINKED',
    2303: 'VIDYO_CLIENT_OUT_EVENT_SIGNED_IN',
    2304: 'VIDYO_CLIENT_OUT_EVENT_SIGNED_OUT',
    2305: 'VIDYO_CLIENT_OUT_EVENT_ROOM_LINK',
    2306: 'VIDYO_CLIENT_OUT_EVENT_CLIENT_VERSION_ON_SERVER',
    2400: 'VIDYO_CLIENT_OUT_EVENT_ENABLED_STATUS_BAR',
    2401: 'VIDYO_CLIENT_OUT_EVENT_ENABLED_BUTTON_BAR',
    2450: 'VIDYO_CLIENT_OUT_EVENT_SELECTED_PARTICIPANTS_CHANGED',
    2500: 'VIDYO_CLIENT_OUT_EVENT_CALL_STATE',
    2600: 'VIDYO_CLIENT_OUT_EVENT_GROUP_CHAT',
    2601: 'VIDYO_CLIENT_OUT_EVENT_PRIVATE_CHAT',
    2700: 'VIDYO_CLIENT_OUT_EVENT_ALARMS_RAISED',
    2701: 'VIDYO_CLIENT_OUT_EVENT_ALARMS_CLEARED',
    2710: 'VIDYO_CLIENT_OUT_EVENT_PORTAL_PREFIX',
    2715: 'VIDYO_CLIENT_OUT_EVENT_PORTAL_FEATURES',
    2720: 'VIDYO_CLIENT_OUT_EVENT_CPU_USAGE_ACTIONS',
    2800: 'VIDYO_CLIENT_OUT_EVENT_LECTURE_MODE_STAGE',
    2802: 'VIDYO_CLIENT_OUT_EVENT_LECTURE_MODE_PRESENTER_CHANGED',
    2803: 'VIDYO_CLIENT_OUT_EVENT_LECTURE_HAND_CLEARED',
    2810: 'VIDYO_CLIENT_OUT_EVENT_AUDIO_FRAME_RECEIVED',
    2811: 'VIDYO_CLIENT_OUT_EVENT_VIDEO_FRAME_RECEIVED',
    2812: 'VIDYO_CLIENT_OUT_EVENT_SELF_VIEW_VIDEO_FRAME_RECEIVED',
    2820: 'VIDYO_CLIENT_OUT_EVENT_CONTROL_CONFERENCE_ROOM_SETTINGS',
    2830: 'VIDYO_CLIENT_OUT_EVENT_PRECALL_TEST_DEVICE',
    2850: 'VIDYO_CLIENT_OUT_EVENT_SHARED_WINDOW_CLOSED',
    2851: 'VIDYO_CLIENT_OUT_EVENT_SHARED_SCREEN_DISCONNECTED',
    2855: 'VIDYO_CLIENT_OUT_EVENT_CONFERENCE_CONTROL_ALL_PARTICIPANTS',
    2860: 'VIDYO_CLIENT_OUT_EVENT_NETWORK_INTERFACE_CHANGED',
    3000: 'VIDYO_CLIENT_OUT_EVENT_PORTAL_SERVICE',
    99999: 'VIDYO_CLIENT_OUT_EVENT_MAX'
}

const PrivateEventNames = {
    200100: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_MIN',
    200200: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_SHARED_APP_ADD',
    200201: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_SHARED_APP_REM',
    200300: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_ALARMS_RAISED',
    200301: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_ALARMS_CLEARED',
    200400: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PARTICIPANTS_LIMIT_BANDW',
    200401: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PARTICIPANTS_LIMIT_SAFE',
    // Use VIDYO_CLIENT_OUT_EVENT_PARTICIPANTS_CHANGED instead of this
    200600: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PARTICIPANTS_CHANGED',
    200700: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_ALLOW_UPGRADE',
    200800: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_GET_CONFIGURATION_RESPONSE',
    200900: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_VCSOAP',
    // all OUT events related to caching portal data and operations on cache
    201000: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PORTAL_DATA_CACHE',
    // inform the user that a sound buffer finished playing , using VidyoClientInEventPlaySound structure
    201100: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PLAY_SOUND_DONE',
    // Inform listener (Android app. for example) to run the Web Proxy PAC script
    201200: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_WEBPROXY_UPDATE_NEEDED',
    // Inform listener that a guest conference has just ended
    201300: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_GUEST_CONFERENCE_ENDED',
    // Inform listener that a reset emcp after guest conference has just failed. client is now in a logout state.
    201400: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_RESET_EMCP_AFTER_GUEST_FAILED',
    201600: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_LOG',    // logs sent to application
    201700: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_GUEST_CONFERENCE_BEGIN_PROMPT',  // guest link notification
    // 201810: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_CONFERENCE_CLEARED',
    /*!
    Report the status of communication with Portal. This out event is used
    report the portal communication status for searching contact, add or remove contacts,
    control meeting etc.

    @see Corresponding parameter structure #VidyoClientPrivateOutEventPortalCommunicationStatus
    */
    201900: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PORTAL_COMMUNICATION_STATUS',
    /*!
    Report the changes in signin flow. Example of changes are retry to secure portal,
    redirecting to secure portal.

    @see Corresponding parameter structure #VidyoClientPrivateOutEventSignInUpdate
    */
    202000: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_SIGNIN_UPDATE',
    /*!
    Report that user login using external (e.g. browser) or Report that automatic login
    using previously provided credntial is started.

    @see Corresponding parameter structure #VidyoClientPrivateOutEventLoginStarted
    */
    202001: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_LOGIN_STARTED',
    /*!
    Report that credential required to login are not present or client is working again older
    portal and manual sign-in required.

    @see Corresponding parameter structure #VidyoClientPrivateOutEventNoLoginCredential
    */
    202002: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_NO_LOGIN_CREDENTIAL',
    /*!
    Report the status change Kiosk device.

    @see Corresponding parameter structure #VidyoClientPrivateOutEventKioskDeviceStateChanged
    */
    202100: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_KIOSK_DEVICE_STATE_CHANGED',
    /*!
    Report the low master volume indication for a audio device.

    @see Corresponding parameter structure #VidyoClientPrivateOutEventLowMasterVolume
    */
    202110: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_LOW_MASTER_VOLUME',

    // /* Start of messages for VidyoRoom only */
    // 250000: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_VISCA',
    // 250001: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_SWB',
    // 250002: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_USB_CAPTURE',
    // 250003: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_CHANGE_FOCUS',
    // 250004: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_NETWORK_CONTROL',
    // 250005: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_CHANGE_CAMERA_MODE',
    // 250006: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_FRAMEWORK_DONE',
    // 250007: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_ADJUST_MONITORS',
    // 250008: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_SET_VISCA',
    // /* End of messages for VidyoRoom only */

    // /* Start of messages used by Android (currently) */
    // /*!
    // Report that a Remote source is added or removed.  Android needs to know when remote
    // sources are added and removed so that if the menu bar is visible it can be updated
    // appropriately.
    // */
    // 260000: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_REMOTE_SOURCE_ADD',
    // 260001: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_REMOTE_SOURCE_REM',
    // /* End of messages used by Android (currently) */
    260002: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_RENDERER_DOCS_CHANGED',

    /* Start of messages used by VidyoWeb ONLY */
    270000: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PLUGIN_CONNECTION_SUCCESS',
    270001: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_PLUGIN_CONNECTION_FAILURE',
    270002: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_GET_WINDOWS_EXT',
    /* Below private out event is for declaration only, as its been sent by the VidyoWeb plugin */
    270003: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_GET_JOIN_APPROVAL',
    /* End of messages used by VidyoWeb */

    299999: 'VIDYO_CLIENT_PRIVATE_OUT_EVENT_MAX',


    300500: 'EXTENSION_MSG_CLIENT_CLOSED',
    300501: 'EXTENSION_MSG_CLIENT_STARTING',
    300502: 'EXTENSION_MSG_REQUEST_SET_CHROME_ARCH'
}

const VideoQualityLevels = [
    { name: 'BestQuality', title: 'Best Quality (Recommended)', intValue: 0 },
    { name: 'BestFramerate', title: 'Best Frame Rate', intValue: 1 },
    { name: 'BestResolution', title: 'Best Resolution', intValue: 2 },
    { name: 'LimitedBandwidth', title: 'Limited Bandwidth', intValue: 3 },
    { name: 'Advanced450p30', title: 'Advanced: 450p30', intValue: 10 },
    { name: 'Advanced720p15', title: 'Advanced: 720p15', intValue: 11 },
    { name: 'Advanced720p30', title: 'Advanced: 720p30', intValue: 12 }
]

interface IVideoQualityLevel {
    name: string
    title: string
    intValue: number
}


namespace SmartVideo {
export class ChromeWrapper {
    eventNames: {};
    privateEventNames: {};
    callbacks: Function[];
    timeouts: number[];
    chromeproxy: ChromeProxy;
    videoHandler: VideoHandler;
    supportedVideoQualityLevels: IVideoQualityLevel[];
    browser: string;
    isSmartVideoAgent: boolean;

    constructor(browser: string) {
        this.videoHandler = new VideoHandler(this.sendEvent.bind(this));
        this.chromeproxy = new ChromeProxy(browser, this.videoHandler, this.sendEvent.bind(this), this.receivedEvent.bind(this));
        // this.populateEventNames();
        this.eventNames = EventNames;
        // this.populatePrivateEventNames();
        this.privateEventNames = PrivateEventNames;
        // this.populateQualityLevels();
        this.supportedVideoQualityLevels = VideoQualityLevels;
        this.callbacks = [];
        this.timeouts = [];
        this.browser = browser;
        this.isSmartVideoAgent = false;
        if (browser === 'SmartVideoAgent') {
            this.isSmartVideoAgent = true;
        }
    }

    receivedEvent(event) {
        const message = event.data;
        if (message.type === 'log') {
            try {
                console.log('rcv from ext:', JSON.stringify(message));
            } catch (error) {
                console.log(message);
            }
        } else {
            try {
                console.log('rcv from ext:', JSON.stringify(message));
            } catch (error) {
                console.log(message);
            }
        }

        if (message._direction === 2) {
            if (message.type) {
                if (message.type.indexOf('OUT_EVENT') === -1) {
                    if (this.callbacks[message._id] && this.timeouts[message._id]) {
                        clearTimeout(this.timeouts[message._id]);
                        delete this.timeouts[message._id];
                        this.callbacks[message._id](message);
                        delete this.callbacks[message._id];
                    }
                    return;
                }
            }
            // Handle OutEvents
            const evtCode = message['code'];
            const evtParams = message['params'];

            const evt = <any>{};
            // create an object to dispatch
            if (this.eventNames[evtCode] !== undefined) {
                evt.type = this.eventNames[evtCode];
            } else if (this.privateEventNames[evtCode] !== undefined) {
                evt.type = this.privateEventNames[evtCode];
            } else {
                evt.type = null;
            }

            for (const param in evtParams) {
                if (evtParams.hasOwnProperty(param)) {
                    evt[param] = evtParams[param];
                }
            }
            switch (evt.type) {
                case 'VIDYO_CLIENT_OUT_EVENT_LOGIC_STARTED':
                    break;
                case 'VIDYO_CLIENT_OUT_EVENT_CONFERENCE_ENDED':
                    console.log('Stopping media stream in VideoHandler');
                    this.videoHandler.stop();
                    break;
                case 'EXTENSION_MSG_CLIENT_CLOSED':
                    this.chromeproxy.starting = false;
                    if (evt.message === 'Specified native messaging host not found.' && navigator.appVersion.indexOf('Mac') !== -1) {
                        localStorage.setItem('shouldRestartChrome', 'true');
                    }
                    break;
                default:
                    break;
            }

            if (evt.type) {
                if (evtCode !== 200900/*VIDYO_CLIENT_PRIVATE_OUT_EVENT_VCSOAP*/) {
                    evt.type = evt.type.toLowerCase();
                    evt.type = evt.type.replace(/(_([a-zA-Z]{1}))/g, function($1) { return $1.toUpperCase(); });
                    evt.type = evt.type.replace(/_/g, '');
                    if (evtCode !== 300500 && evtCode !== 300501 && evtCode !== 300502) {
                        evt.type = evt.type.substring(11);
                    }
                }
                this.dispatch(evt);
            } else {
                console.log('event without type', message);
            }
        }
    }

    sendEvent(obj, callback) {
        obj._id = Math.floor(Math.random() * 1000000);
        this.callbacks[obj._id] = callback;
        clearTimeout(this.timeouts[obj._id]);

        this.timeouts[obj._id] = setTimeout(() => {
            console.log('Timeout callback has been set for:', obj.type);
            obj.error = 'connection timeout';
            if (this.callbacks[obj._id] && this.timeouts[obj._id]) {
                this.callbacks[obj._id](obj);
            }
        }, 2000);

        obj._direction = 1;

        console.log('snd to ext:', JSON.stringify(obj));
        if (!this.isSmartVideoAgent) {
            window.postMessage(obj, '*');
        } else {
            // SmartVideoAgent injects this function at runtime, so ignore TS error
            window['VidyoSendMessage'](JSON.stringify(obj));
        }
    }

    dispatch(object) {
        if (this.chromeproxy.dispatchFunction) {
            this.chromeproxy.dispatchFunction(object);
        }
    }
}}
